import React, {useState} from "react";
import {create_checkout_session} from "../api/backendApi";
import {BASIC_ID, PRO_MONTHLY_ID, PRO_YEARLY_ID, EXPERT_MONTHLY_ID, EXPERT_YEARLY_ID} from "../env";
import SubscriptionBox from "../components/subscriptionBox";
import SwitchComponent from "../components/switchComponent";
import Heading from "../components/heading";
import {ReactComponent as PaySvg} from "../assets/images/pay.svg";
import {ReactComponent as TradingViewLogo} from "../assets/images/tradingview-logo-vector.svg";
import {NavbarContainer} from "../components/templates/navbar/Navbar";

const subscriptions = [
    {
        title: 'Basic',
        textFeatures: 'BASIC plan includes:',
        features: [
            {text: 'AI-Powered Assistant.', included: true},
            {text: 'The ability to generate 10 analyses with a single click.', included: true},
            {text: 'Lifetime access to our Discord community.', included: true},
            {text: 'Instant access to educational materials.', included: true},
            {text: 'Participation in regularly organized webinars with experts.', included: true},
            {text: 'Possibility to purchase additional analyses - $5 per package of 10 analyses.', included: true},
        ],
        costWeekly: '$9.99',
        buttonText: 'Subscribe',
        isHighlighted: false,
        bottomText: 'Best to test',
        monthlyCosts: {
            costWeekly: '$9.99',
            costWeeklyWithoutDiscount: '$14.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: 'https://charts.lockedtrade.com/#/subscriptions/basic'
        },
        yearlyCosts: {
            costWeekly: '$9.99',
            costWeeklyWithoutDiscount: '$14.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: 'https://charts.lockedtrade.com/#/subscriptions/basic'
        },
        onlyMonthly: true,
    },
    {
        title: 'Expert',
        textFeatures: 'EXPERT plan includes:',
        features: [
            {text: 'AI-Powered Assistant.', included: true},
            {text: 'The ability to generate 150 analyses.', included: true},
            {text: 'Lifetime access to our Discord community.', included: true},
            {text: 'Instant access to educational materials.', included: true},
            {text: 'Participation in regularly organized webinars with experts.', included: true},
            {
                text: 'Access to live trading sessions where you’ll learn professional strategies used by our team.',
                included: true
            },
            {text: 'Possibility to purchase additional analyses - $25 per package of 100 analyses.', included: true},
        ],
        costMonthly: '$49.99',
        costYearlyWithDiscount: '$527.89',
        costYearlyWithoutDiscount: '$599.88',
        buttonText: 'Subscribe',
        isHighlighted: true,
        bottomText: 'Best price per one analyses',
        monthlyCosts: {
            costMonthly: '$49.99',
            costMonthlyWithoutDiscount: '$74.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: 'https://charts.lockedtrade.com/#/subscriptions/expert-monthly'
        },
        yearlyCosts: {
            costYearly: '$527.89',
            costYearlyWithoutDiscount: '$899.88',
            discountPercent: '-41%',
            isDiscount: true,
            url: 'https://charts.lockedtrade.com/#/subscriptions/expert-yearly'
        },
        onlyMonthly: false,
    },
    {
        title: 'Pro',
        textFeatures: 'PRO plan includes:',
        features: [
            {text: 'AI-Powered Assistant.', included: true},
            {text: 'The ability to generate 50 analyses.', included: true},
            {text: 'Lifetime access to our Discord community.', included: true},
            {text: 'Instant access to educational materials.', included: true},
            {text: 'Participation in regularly organized webinars with experts.', included: true},
            {
                text: 'Access to live trading sessions where you’ll learn professional strategies used by our team.',
                included: true
            },
            {text: 'Possibility to purchase additional analyses - $15 per package of 50 analyses.', included: true},
        ],
        costMonthly: '$29.99',
        costYearlyWithDiscount: '$316.69',
        costYearlyWithoutDiscount: '$359.88',
        buttonText: 'Subscribe',
        isHighlighted: false,
        bottomText: 'Most popular',
        monthlyCosts: {
            costMonthly: '$29.99',
            costMonthlyWithoutDiscount: '$44.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: 'https://charts.lockedtrade.com/#/subscriptions/pro-monthly'
        },
        yearlyCosts: {
            costYearly: '$316.69',
            costYearlyWithoutDiscount: '$539.88',
            discountPercent: '-41%',
            isDiscount: true,
            url: 'https://charts.lockedtrade.com/#/subscriptions/pro-yearly'
        },
        onlyMonthly: false,
    },
];

const Subscriptions = () => {
    const [isMonthly, setIsMonthly] = useState(true);

    const handleIsMonthly = () => {
        setIsMonthly(!isMonthly);
    };

    return (
        <>
            <div className="dark-bg-with-gradients">
                <NavbarContainer/>
            </div>
            <section className="section-subscriptions pb-7">
                <div className="generic-container pt-14" style={{ position: 'relative' }}>
                    {/* Add "X" button to right top corner */}
                    <button
                        className="close-button"
                        onClick={() => window.history.back()}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                    <Heading level={2}>Choose your plan</Heading>
                    <Heading level={3}>Pay yearly and get a discount!</Heading>
                    <SwitchComponent isMonthly={isMonthly} handleIsMonthly={handleIsMonthly}/>
                    <div
                        className={`subscription-boxes-container`}>
                        {subscriptions.map((sub, index) => (
                            <SubscriptionBox key={index} {...sub} isMonthly={isMonthly}/>
                        ))}
                    </div>
                </div>
            </section>
            <section className="section-secure-checkout">
                <div className="generic-container">
                    <img src={require('../assets/images/stripe-secure.png')} alt="secure checkout"
                         className="w-full object-cover"/>
                    <PaySvg/>
                </div>
            </section>
            <section className="section-powered-by">
                <div className="generic-container gap-5">
                    <div className="flex justify-center items-center">
                        <p>Powered by</p>
                    </div>
                    <div className="flex justify-center items-center">
                        <TradingViewLogo/>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Subscriptions;